/** Toggle membership in a Set; returns a new Set (CODE_CLEANUP_SPEC). */
export function toggleSetMember<T>(set: Set<T>, value: T): Set<T> {
  const next = new Set(set);
  if (next.has(value)) {
    next.delete(value);
  } else {
    next.add(value);
  }
  return next;
}
